import { connect } from 'react-redux';

import { deleteById, Entities, fetchByCompanyId, getEntities, save, search } from 'src/common/index';
import { fetchOwnBusCompany } from 'src/actions/bus-companies';
import { getOwnCompany } from 'src/selectors/bus-companies';
import ZoneCalculationAdministration from 'src/components/administration/zone-calculation/zone-calculation-administration';
import { addNotification } from 'src/actions/notifications';
import { push } from 'react-router-redux';
import { asyncCheckDuplicate } from 'src/components/misc/redux-form-helpers';

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
        countryCalculations: getEntities(state, Entities.COUNTRY_CALCULATION, state.selectedCompany),
        geofenceCalculations: getEntities(state, Entities.GEOFENCE_CALCULATIONS),
        geofenceAreas: getEntities(state, Entities.GEOFENCE_AREA),
        busCompany: getOwnCompany(state),
        zoneCalculations: getEntities(state, Entities.ZONE_CALCULATION),
    };
};

const ZoneCalculationAdministrationContainer = connect(mapStateToProps, {
    fetchByCompanyId,
    save,
    search,
    addNotification,
    fetchOwnBusCompany,
    deleteById,
    push,
    asyncCheckDuplicate,
})(ZoneCalculationAdministration);

export default ZoneCalculationAdministrationContainer;
